import UpdateMessage from "./UpdateMessage";
import "./update-message.scss";

export default UpdateMessage;
